/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generate_Failed_ToastInputs */

const en_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate offline activation code.`)
};

const fr_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de la generation du code d'activation hors ligne.`)
};

const de_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es konnte kein Offline-Aktivierungscode generiert werden.`)
};

const it_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile generare il codice di attivazione offline.`)
};

const ru_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось сгенерировать код активации для работы в автономном режиме.`)
};

const es_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar el código de activación sin conexión.`)
};

const zh_cn2_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线激活码生成失败。`)
};

const ja_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインアクティベーションコードの生成に失敗しました。`)
};

const hi_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफलाइन सक्रियण कोड जनरेट करने में विफल।`)
};

const pt_pt2_offline_activation_generate_failed_toast = /** @type {(inputs: Offline_Activation_Generate_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao gerar o código de ativação offline.`)
};

/**
* | output |
* | --- |
* | "Failed to generate offline activation code." |
*
* @param {Offline_Activation_Generate_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generate_failed_toast = /** @type {((inputs?: Offline_Activation_Generate_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generate_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_generate_failed_toast(inputs)
	if (locale === "de") return de_offline_activation_generate_failed_toast(inputs)
	if (locale === "it") return it_offline_activation_generate_failed_toast(inputs)
	if (locale === "ru") return ru_offline_activation_generate_failed_toast(inputs)
	if (locale === "es") return es_offline_activation_generate_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_generate_failed_toast(inputs)
	if (locale === "ja") return ja_offline_activation_generate_failed_toast(inputs)
	if (locale === "hi") return hi_offline_activation_generate_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_generate_failed_toast(inputs)
	return en_offline_activation_generate_failed_toast(inputs)
});